<template>
  <div class="pl-3 pt-3 pb-2 bg-light-fracture1 rounded-top">
    <h4 class="modal-title">資料を追加</h4>
  </div>
  <div class="p-3 overflow-auto pt-2" style="max-height:90vh;border-top:0px solid silver;border-bottom:0px solid silver;" v-if="mutateViewModel">
    <!-- 背景図アップロード(図面を使用する場合) -->
    <div class="d-flex flex-column pl-3 pr-3" >
      <!-- <el-upload
        class="flex-fill w-100 justify-content-left align-items-baselin upload-conainer"
        action=""
        drag
        v-if="uploadFiles.length == 0"
        ref="upload"
        :auto-upload="false"
        :file-list="uploadFiles"
        :thumbnail-mode="true"
        :on-change="addFile"
        :on-remove="removeFile"
        :disabled="uploadFileList.length > 0"
        :multiple="false"
      >
        <div class="d-flex flex-column">
          <div class="flex-fill">ここにファイルをドラッグ＆ドロップ</div>
          <div>または</div>
          <el-button size="small" type="primary" class="bg-primary border-0 ml-2 mr-2 mt-3 mb-3"><span style="font-size:1.2rem;">背景図ファイルを選択</span></el-button>
          <div style="font-size:0.8rem;">1ファイル100MBまで、10ファイルまでアップロードできます</div>
        </div>
        
      </el-upload> -->

      <el-upload
        class="flex-fill w-100 justify-content-left align-items-baseline upload-conainer"
        action=""
        drag
        :on-change="handleOnChange"
        :on-remove="handleRemove"
        :file-list="uploadFileList"
        :multiple="true"
        :auto-upload="false"
        :disabled="uploadFileList.length >= 10"
        :limit="10"
      >
        <div class="d-flex flex-column">
          <div class="flex-fill">ここにファイルをドラッグ＆ドロップ</div>
          <div>または</div>
          <el-button size="small" v-if="uploadFileList.length < 10" type="primary" class="bg-primary border-0 ml-2 mr-2 mt-3 mb-3"><span style="font-size:1.2rem;">ファイルを選択</span></el-button>
          <el-button size="small" v-if="uploadFileList.length >= 10" disabled type="primary" class="bg-primary border-0 ml-2 mr-2 mt-3 mb-3"><span style="font-size:1.2rem;">ファイルを選択</span></el-button>
          <div style="font-size:0.8rem;">1ファイル100MBまで、10ファイルまでアップロードできます</div>
        </div>
        
      </el-upload>
      
      <!-- <div class="d-flex" v-if="uploadFileList.length > 0">
        <div class="flex-grow-1">
          選択したファイル：{{uploadFileList[0].name}}
        </div>
        
        <base-button
          
          type="primary"
          @click="onClickRemoveFile"
          >ファイルを削除する</base-button
        >
      </div> -->
    </div>
  </div>
  <div class="d-flex p-3">
    <div class="my-box flex-fill pr-1">
      <base-button
        block
        type="secondary"
        @click="onClickCancel"
        >{{$t("共通.13")}}</base-button
      >
    </div>
    <div class="my-box flex-fill pl-1">
      <base-button
        block
        type="primary"
        @click="onClickSave"           
        >{{$t("共通.14")}}</base-button
      >
    </div>
  </div>
</template>
<style>

</style>
<script>
import constants from "@/Config/constants";
import s3Util from "@/awsUtil/s3Util";
import ValidateUtil from "@/appUtils/ValidateUtil"
import TenantStorage from "@/appUtils/TenantStorage"
import { useToast } from "vue-toastification";
import FileUploadViewModel from "@/appViews/components/FileView/ViewModel/FileUploadViewModel"
import mime from 'mime-types';
const path = require('path')

export default {
  components: {
  },
  props: {
    viewModel: {
      type: Object
    }
  },
  watch: {
    mutateViewModel: {
      handler: function () {
        this.modified = true
      },
      deep: true
    }
  },
  data() {
    return {
      tenantId: null,
      parentSk: null,
      loader: null,
      targetNodeId: null,
      mutateViewModel: null,
      showConfirm: false,
      confirm: {
        tirle: "削除確認",
        message: "",
        leftButtonLabel: "キャンセル",
        rightButtonLabel: "削除",
        leftButtonFn: null,
        rightButtonFn: null
      },
      modified: false,
      uploadFileList: [],
      tenantStorage: null,
      rules: {
        name: [{ required: true, validator: this.checkBackImageName, trigger: 'blur' }],
        inspectMasterList: [{ required: true, validator: this.checkInspectMasterList, trigger: 'blur' }]
      },
      toastId: "inspectIconModal",
      isCopyBackImage: false,
      isFigureCopy: false
    };
  },
  beforeCreate() {
    //インスタンスは生成されたがデータが初期化される前
  },
  created() {
    
  },
  beforeMount() {
    //インスタンスが DOM 要素にマウントされる前
    this.init().then(function(){
      console.log(``)
    })
  },
  mounted() {
    //インスタンスが DOM 要素にマウントされた後
  },
  beforeUpdate() {
    //データは更新されたが DOM に適用される前
  },
  updated() {
    //データが更新され､且つ DOM に適用された後
  },
  beforeUnmount() {
    //Vue インスタンスが破壊される前
  },
  unmounted() {
    //Vue インスタンスが破壊された後
  },
  //ボタンイベントなどのメソッドはmethodsに
  methods: {
    async init() {
      try {
        const tenantStore = this.$store.state.tenant
        this.tenantId = tenantStore.id
        this.tenantStorage = new TenantStorage(this.tenantId)
        // this.uploadFileList = [""]
        // ViewModelをプロパティのオブジェクトから初期化
        await this.initViewModel()
        this.modified = false
        
      } catch (e){
        console.log(JSON.stringify(e, null, "\t"))
        throw e
      
      }
    },
    chengeInspectMaster(){

    },
    async initViewModel() {
      
      this.mutateViewModel = new FileUploadViewModel()
      this.mutateViewModel = Object.assign(this.mutateViewModel, JSON.parse(JSON.stringify(this.viewModel)))
      
    },
    /**
     * モーダルのキャンセル
     */
    onClickCancel() {
      if (this.modified) {
        // 変更確認
        this.confirm.message = `変更内容が破棄されますがよろしいですか？`
        this.confirm.leftButtonLabel = "編集に戻る"
        this.confirm.rightButtonLabel = "破棄する"
        this.confirm.leftButtonFn = function() {
          this.showConfirm = false
        }.bind(this)
        this.confirm.rightButtonFn = function() {
          this.showConfirm = false
          this.$emit("onCancel");
        }.bind(this)
        this.showConfirm = true
      } else {
        this.$emit("onCancel");
      }
      
    },
    handleOnChange(file, fileList){
      const sizeMb = file.size / 1024 / 1024;
      const isOverSize = sizeMb > 100;

      if (isOverSize) {
        this.runToast(`ファイルサイズが100MBを超えています。 ${file.name}`, "error")
      }

      let contentType = mime.lookup(file.name)
            
      if (contentType != "application/pdf" && contentType != "image/jpeg" && contentType != "image/png") {
        this.runToast("対応していないファイル形式です", "error")
      }

      let result = fileList.filter((file) => {
        const sizeMb = file.size / 1024 / 1024;

        let contentType = mime.lookup(file.name)
        let isValidType = contentType == "application/pdf" || contentType == "image/jpeg" || contentType == "image/png"
        return sizeMb <= 100 && isValidType;
      });

      this.uploadFileList = result

    },
    handleRemove(file, fileList){
      this.uploadFileList = fileList
    },
    /**
     * ファイルをアップロード
     */
    async uploadFile() {

      if (this.uploadFiles.length == 0) {
        return
      }
      const file = this.uploadFiles[0];
      if (!file.raw) {
        return
      }
      try {
        const projectId = this.mutateViewModel.projectId
        const nodeId = this.mutateViewModel.nodeId

        if (!this.tenantId || !projectId || !nodeId) {
          throw `パラメータ不足`
          
        }

        // S3キー名
        const s3Key = `${this.tenantStorage.getBaseDir()}${projectId}/${nodeId}/${file.name}`
        // ファイルサイズ
        const fileName = file.name
        const fileBody = file.raw

        let contentType = mime.lookup(file.name)
        //const option = {level: "public", contentType: contentType}
        const option = {"ContentType": contentType}

        try {
          // S3バケットにファイルを保存
          await this.tenantStorage.put(s3Key, fileBody, option)
        } catch (e) {
          alert(`S3アップロード失敗 ${e.message}`)
          throw e
        }
        // 更新データにファイル名とキーをセット
        // this.mutateViewModel.backImage.backImage.name = path.basename(this.uploadFiles[0].name);
        this.mutateViewModel.backImage.backImage.filePath = s3Key

        // const ext = fileName.split(".")[1].toLowerCase()

      } catch (e) {
        alert(e.message)
        throw e
      } finally {
        // this.hideLoader(loader);
      }
    },
    async deleteFile() {
      try {
        const s3key = this.mutateViewModel.backImage.backImage.filePath
        await this.tenantStorage.delete(s3key)

      } catch (e) {
        console.log(`削除失敗 ${JSON.stringify(e)}`)
      }
    },
    async onChangeBackType(value) {

    },
    async onChangeSourceType(value) {

    },
    /**
     * モーダルの保存
     */
    async onClickSave() {
      this.hideToast()
      this.showLoader()
      try {
        // 指定ファイルをアップロード
        for (let i = 0; i < this.uploadFileList.length;i++){
          const file = this.uploadFileList[i]
          const fileSize = file.size
          const fileName = file.name
          const fileBody = file.raw
          await this.mutateViewModel.init(fileBody, fileName, fileSize)
          await this.mutateViewModel.save()
        }
        
        this.$emit("onSave");
      } catch (e) {
        console.log(`${JSON.stringify(e)}`)
        throw e
      } finally {
        this.hideLoader()
      }
    },
    onClickConfirmLeft() {
      this.confirm.leftButtonFn()
    },
    onClickConfirmRight() {
      this.confirm.rightButtonFn()
    },
    
    /**
     * 処理中インジケーターを表示します。
     * @returns 表示したインジケーター
     */
    showLoader() {
      this.loader = this.$loading.show({
        container: null,
        canCancel: false,
        color: "#E4007F",
        width: 64,
        height: 64,
        backgroundColor: "#ffffff",
        opacity: 0.5,
        isFullPage: true,
        zIndex: 9999,
      })
    },
    onClickRemoveFile(){
      // this.$refs.upload.clearFiles()
      this.uploadFiles = []
      this.$nextTick(function(){
        this.$refs.upload.clearFiles()
      }.bind(this))
    },
    /**
     * 処理中インジケーターを閉じます。
     * @paramas {Object} loader 表示したインジケーター
     */
    hideLoader() {
      this.loader.hide();
    },
    // ----------------
    // トースト
    // ----------------
    /**
     * トースト表示
     */
    runToast(message, type) {
      const pos = 'bottom-center'
      const toast = useToast();
      toast[type](message, {
        hideProgressBar: true,
        icon: false,
        toastClassName: ["custome-toast-class"],
        closeButton: false,
        position: pos,
        id: this.toastId
      });
    },
    /**
     * トースト非表示
     */
    hideToast() {
      const toast = useToast();
      toast.dismiss(this.toastId)
    }
  }
};
</script>